<template>
  <span
    class="back-link"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space="handleClick"
  >
    <span class="material-icons-outlined">chevron_left</span> {{ label }}
  </span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: '戻る',
  },
);

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.back-link {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  width: fit-content;
  padding: 8px 0;
  font-size: 0.875rem;
  color: $tertiary-color;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s ease;

  &:hover,
  &:focus {
    color: $primary-color;
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid $primary-color;
    outline-offset: 2px;
    border-radius: 4px;
  }
}
</style>
